export const UPDATE_AUTH_USER_ORGANIZATIONS = 'organization/UPDATE_AUTH_USER_ORGANIZATIONS'
export const UPDATE_ORGANIZATIONS_PAGE = 'organization/UPDATE_ORGANIZATIONS_PAGE'
export const CURRENT_ORGANIZATION_TERMINALS = 'organization/CURRENT_ORGANIZATION_TERMINALS'
export const UPDATE_ORGS_AMOUNT = 'organization/UPDATE_ORGS_AMOUNT'
export const CLEAR_STATE = 'organization/CLEAR_STATE'
export const TERMINALS_LOADING = 'organization/TERMINALS_LOADING'
export const CLEAR_TERMINALS = 'organization/CLEAR_TERMINALS'
